import type { Lang } from "../../i18n/I18nProvider";

const UNITS: readonly (readonly [Intl.RelativeTimeFormatUnit, number])[] = [
  ["day", 86_400_000],
  ["hour", 3_600_000],
  ["minute", 60_000],
];

/** Relative time such as "2 hours ago", or "now" under a minute. Falls back to the raw text. */
export function formatRelative(value: string, lang: Lang, now: number = Date.now()): string {
  const time = new Date(value).getTime();
  if (Number.isNaN(time)) return value;
  const format = new Intl.RelativeTimeFormat(lang === "sr" ? "sr-Latn" : "en-GB", {
    numeric: "auto",
  });
  const diff = time - now;
  const unit = UNITS.find(([, ms]) => Math.abs(diff) >= ms);
  if (!unit) return format.format(0, "minute");
  const [name, ms] = unit;
  return format.format(Math.round(diff / ms), name);
}
